import { getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useInView } from 'react-intersection-observer';

import { propTypesDataQuestionsType } from './QuestionsType.proptypes.js';

import { useSize } from '../../../hooks/useSize';

import Picture from '../../../../ui/Atoms/Picture';

import { Color } from '../../../constants/Colors';
import * as S from './QuestionsType.styles.js';

const renderCards = ({ cards, currentCard, cardAmount }) => {
  if (!cards) {
    return null;
  }

  const cardsToShow = [];

  if (cardAmount === 3) {
    if (currentCard === 0) {
      cardsToShow.push(cards[cards.length - 1]);
    } else {
      cardsToShow.push(cards[currentCard - 1]);
    }

    cardsToShow.push(cards[currentCard]);
    if (currentCard + 1 === cards.length) {
      cardsToShow.push(cards[0]);
    } else {
      cardsToShow.push(cards[currentCard + 1]);
    }
  } else {
    cardsToShow.push(cards[currentCard]);
  }

  return (
    <S.CardsWrapper>
      {cardsToShow.map((card, index) => {
        const {
          questions_type_card_title: titleCard,
          questions_type_card_illustration: { alt },
        } = card || '';

        const image = getImage(card.questions_type_card_illustration);

        const isCurrentCard = cardAmount === 1 ? index === 0 : index === 1;

        return (
          <S.Card isCurrentCard={isCurrentCard} key={`${card}-${index}`}>
            <S.IllustrationWrapper isCurrentCard={isCurrentCard}>
              <Picture altText={alt} imageObject={image} />
            </S.IllustrationWrapper>
            <S.CardTitle isCurrentCard={isCurrentCard}>{titleCard}</S.CardTitle>
          </S.Card>
        );
      })}
    </S.CardsWrapper>
  );
};

export const QuestionsTypeSlice = ({ slice }) => {
  const { ref } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });
  const [currentCard, setCurrentCard] = useState(1);
  const isMobile = useSize().width < 1024;

  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const { questions_type_slice_id: id, questions_type_title: title } =
    data || '';

  const questionsType = slice.items || {};

  const handleNextCard = () => {
    if (questionsType.length === currentCard + 1) {
      setCurrentCard(0);
    } else {
      setCurrentCard(currentCard + 1);
    }
  };

  const handlePreviousCard = () => {
    if (currentCard === 0) {
      setCurrentCard(questionsType.length - 1);
    } else {
      setCurrentCard(currentCard - 1);
    }
  };

  if (!title) {
    return null;
  }

  const cardAmount = isMobile ? 1 : 3;

  return (
    <S.QuestionsType id={id} isVisible={true} ref={ref}>
      <S.WrapperTitle>
        <S.QuestionsTypeTitle>{title}</S.QuestionsTypeTitle>
      </S.WrapperTitle>
      <S.Content>
        {renderCards({ cards: questionsType, currentCard, cardAmount })}
      </S.Content>
      <S.ControlsContainer>
        <S.CustomIcon onClick={() => handlePreviousCard()}>
          <S.LinearGradient
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
          >
            <S.LinearGradient
              id='custom-gradient'
              x1='100%'
              x2='0%'
              y1='0%'
              y2='100%'
            >
              <stop offset='0%' stopColor={Color.BLUE_DODGER} />
              <stop offset='100%' stopColor={Color.BLUE_RIBBON} />
            </S.LinearGradient>
          </S.LinearGradient>
          <FaChevronLeft />
        </S.CustomIcon>
        <S.CustomIcon onClick={() => handleNextCard()}>
          <S.LinearGradient
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
          >
            <S.LinearGradient
              id='custom-gradient'
              x1='100%'
              x2='0%'
              y1='0%'
              y2='100%'
            >
              <stop offset='0%' stopColor={Color.BLUE_DODGER} />
              <stop offset='100%' stopColor={Color.BLUE_RIBBON} />
            </S.LinearGradient>
          </S.LinearGradient>
          <FaChevronRight />
        </S.CustomIcon>
      </S.ControlsContainer>
    </S.QuestionsType>
  );
};

QuestionsTypeSlice.propTypes = {
  /**
   * Content of the QuestionsType slice.
   */
  slice: PropTypes.shape(propTypesDataQuestionsType),
};
